<template>
  <div v-if="ready" id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  computed: {
    ready() {
      return (
        !process.env.VUE_APP_AUTH_ENABLED ||
        !this.$store.state.auth.connected ||
        this.$store.state.auth.token
      )
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@200;400;500;600&display=swap');
#app {
  font-family: 'Raleway', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
